<template>
  <Eye
    v-if="item.data.visible || !('visible' in item.data)"
    :size="size"
    :stroke-width="strokeWidth"
    class="cursor-pointer text-gray-400 hover:text-gray-300" />
  <EyeOff v-else :size="size" :stroke-width="strokeWidth" class="cursor-pointer text-gray-500 hover:text-gray-400" />
</template>
<script setup>
import { Eye, EyeOff } from 'lucide-vue-next';

defineProps({
  item: {
    type: Object,
    required: true,
  },
  size: {
    type: Number,
    default: 14,
  },
  strokeWidth: {
    type: [String, Number],
    default: 2,
  },
});
</script>
